export default {"src":"/_next/static/media/asc-animation.99dc69c9.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};